import helper from '@/service/helpers'
import jQuery from 'jquery'

export default {
    data() {
        return {
            swatches: [
                ['', '#000000', '#434343', '#666666', '#999999', '#b7b7b7', '#cccccc', '#d9d9d9', '#efefef', '#f3f3f3'],
                [
                    '#980000',
                    '#ff0000',
                    '#ff9900',
                    '#ffff00',
                    '#00ff00',
                    '#00ffff',
                    '#4a86e8',
                    '#0000ff',
                    '#9900ff',
                    '#ff00ff'
                ],
                [
                    '#e6b8af',
                    '#f4cccc',
                    '#fce5cd',
                    '#fff2cc',
                    '#d9ead3',
                    '#d0e0e3',
                    '#c9daf8',
                    '#cfe2f3',
                    '#d9d2e9',
                    '#ead1dc'
                ],
                [
                    '#dd7e6b',
                    '#ea9999',
                    '#f9cb9c',
                    '#ffe599',
                    '#b6d7a8',
                    '#a2c4c9',
                    '#a4c2f4',
                    '#9fc5e8',
                    '#b4a7d6',
                    '#d5a6bd'
                ],
                [
                    '#cc4125',
                    '#e06666',
                    '#f6b26b',
                    '#ffd966',
                    '#93c47d',
                    '#76a5af',
                    '#6d9eeb',
                    '#6fa8dc',
                    '#8e7cc3',
                    '#c27ba0'
                ],
                [
                    '#a61c00',
                    '#cc0000',
                    '#e69138',
                    '#f1c232',
                    '#6aa84f',
                    '#45818e',
                    '#3c78d8',
                    '#3d85c6',
                    '#674ea7',
                    '#a64d79'
                ],
                [
                    '#85200c',
                    '#990000',
                    '#b45f06',
                    '#bf9000',
                    '#38761d',
                    '#134f5c',
                    '#1155cc',
                    '#0b5394',
                    '#351c75',
                    '#741b47'
                ],
                [
                    '#5b0f00',
                    '#660000',
                    '#783f04',
                    '#7f6000',
                    '#274e13',
                    '#0c343d',
                    '#1c4587',
                    '#073763',
                    '#20124d',
                    '#4c1130'
                ]
            ],
        }
    },

    computed: {
        devMode() {
            return process.env.VUE_APP_DEV_MODE_BACKEND == 'true' ? true : false
        },

        isShowSendNewsletterBlock() {
            return process.env.VUE_APP_SHOW_SEND_NEWSLETTER_BLOCK == 'true' ? true : false
        }
    },

    methods: {
        toNumber(num) {
            return helper.toNumberFormat(num)
        },

        randomPlaceholderImage() {
            let imageArr = []

            for (let i = 1; i <= 4; i++) {
                imageArr.push(`no-image${i}.png`)
            }

            return imageArr[Math.floor(Math.random() * imageArr.length)];
        },

        getQuizImage(quiz, flag) {
            let image
            const baseUrl = process.env.VUE_APP_API_BASE_URL.replace('admin/api', '')

            if (flag && typeof flag != "undefined") {
                if (quiz.image && typeof quiz.image != "undefined" && quiz.image != "") {
                    image = quiz.image
                } else if (quiz.image_placeholder && typeof quiz.image_placeholder != "undefined" && quiz.image_placeholder != "") {
                    image = `${baseUrl}images/${quiz.image_placeholder}`
                } else { // fixed quiz image wrap on question.vue
                    image = `${baseUrl}images/no-image2.png`
                }
            }

            return image
        },

        dateFormat (date) {
            return helper.dateFormat(date)
        },

        fitStageIntoParentContainer(size) {
            const sceneWidth = size.width
            const sceneHeight = size.height

            // now we need to fit stage into parent container
            const containerWidth = this.$refs.stage.getNode().getContainer().offsetWidth ? this.$refs.stage.getNode().getContainer().offsetWidth : size.width

            // but we also make the full scene visible
            // so we need to scale all objects on canvas
            const scale = containerWidth / sceneWidth

            this.$refs.stage.getNode().width(sceneWidth * scale)
            this.$refs.stage.getNode().height(sceneHeight * scale)
            this.$refs.stage.getNode().scale({ x: scale, y: scale })
        },

        async validateForm(form) {
            const isValid = await form.validate();
            return isValid
        },

        scrollToTop(el, smooth = true) {
            if (smooth) {
                el.style.scrollBehavior = 'smooth'
            } else {
                el.style.scrollBehavior = 'unset'
            }

            el.scrollTo(0, 0)
        },

        renderHotspotImage(image) {
            return new Promise (resolve => {
                const canvasImgElement = document.createElement('img')
                const canvas = document.createElement('canvas')
                const ctx = canvas.getContext('2d')
                const imgWidth = image.width
                const imgHeight = image.height

                // Set default canvas size
                canvas.width = imgWidth
                canvas.height = imgHeight

                // Set custom canvas size
                if (imgWidth > imgHeight) {
                    canvas.width = imgHeight
                    canvas.height = imgHeight
                }

                if (imgWidth < imgHeight) {
                    canvas.width = imgWidth
                    canvas.height = imgWidth
                }

                const posX = canvas.width / 2 - imgWidth / 2
                const posY = canvas.height / 2 - imgHeight / 2

                ctx.drawImage(image, posX, posY, imgWidth, imgHeight)

                canvasImgElement.src = canvas.toDataURL()

                canvasImgElement.onload = () => {
                    resolve(canvasImgElement)
                }
            })
        },

        modalInit() {
            jQuery(document).on('hidden.bs.modal', '.modal', function () {
                if (jQuery('body').find('.modal.show').length > 0) {
                    jQuery('body').addClass('modal-open')
                }
            })

            jQuery(document).on('show.bs.modal', '.modal', function () {
                const zIndex = 1040 + 10 * jQuery('.modal:visible').length
                jQuery(this).css('z-index', zIndex)
                setTimeout(() => {
                    jQuery('.modal-backdrop')
                        .not('.modal-stack')
                        .css('z-index', zIndex - 1)
                        .addClass('modal-stack')
                })
            })
        },

        fileSizeReadable(size) {
            let sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            let index = 0

            sizes.forEach(() => {
                if (size > 1024 && index < sizes.length) {
                    size /= 1024;
                    index++
                }
            })

            return size.toFixed(2) + sizes[index];
        }
    }
}
